import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function EmptyState({ message, action }) {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ py: 4, textAlign: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        {message ?? t('no_data_found')}
      </Typography>
      {action ? (
        <Box sx={{ mt: 2 }}>
          {action}
        </Box>
      ) : null}
    </Box>
  );
}
